import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "banner banner-summaries"
}
const _hoisted_3 = { class: "container banner__container" }
const _hoisted_4 = { class: "banner__text-box text-center" }
const _hoisted_5 = {
  itemscope: "",
  itemtype: "https://schema.org/CreativeWork"
}
const _hoisted_6 = {
  class: "banner__title",
  itemprop: "headline"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  class: "highlight-view"
}
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "blockquote-slider" }
const _hoisted_11 = { class: "blockquote-slider__item" }
const _hoisted_12 = { class: "blockquote-slider__text highlight-view__quote" }
const _hoisted_13 = {
  key: 0,
  class: "my-2"
}
const _hoisted_14 = {
  key: 1,
  class: "highlight-view__note"
}

import { computed, onBeforeMount, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import Layout from '@/app/components/Layout.vue'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'
import type { AnnotationWithContent } from '@/models/interfaces'
import { assertNotNull } from '@/helpers/typing'


export default /*@__PURE__*/_defineComponent({
  __name: 'HighlightPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const highlight = ref<AnnotationWithContent | null>(null)

onBeforeMount(async () => {
  try {
    highlight.value = await backend.getHighlight(
      route.params.highlight_id as string,
    )
  } catch (error: any) {
    if (error.request && error.request.status === 404) {
      // Redirect to the non-existing page
      router.push({ name: 'not_found' })
    } else {
      Sentry.captureException(error)
      throw error
    }
  }
})

const bookUrl = computed(() => {
  const content = assertNotNull(highlight.value).content
  return `/app/book/${content.doc.url_slug}/${content.url_slug}/`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", null, [
          (highlight.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("h1", _hoisted_6, [
                        _createElementVNode("a", { href: bookUrl.value }, _toDisplayString(highlight.value.content.doc.title), 9, _hoisted_7)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (highlight.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("blockquote", _hoisted_12, _toDisplayString(highlight.value.quote), 1),
                      (highlight.value.text)
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_13))
                        : _createCommentVNode("", true),
                      (highlight.value.text)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                            _createElementVNode("span", null, _toDisplayString(highlight.value.text), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})